package snow.platform.web.audio;

import snow.audio.Audio;
import snow.types.Types;

    //This is not needlessly empty, it binds an empty platform binding where no implementation exists

class Sound extends snow.audio.Sound.SoundBinding {

} //Sound